import { Component, Input } from '@angular/core';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { SpinnerColor, SpinnerSize } from '@freelancer/ui/spinner';
import { TextAlign, TextSize } from '@freelancer/ui/text';
import { PaymentShareSpendingLimitDurationApi } from 'api-typings/users/users';
import { PaymentShareMemberSpendingInfo } from '../payment-share-member-modal.types';

@Component({
  selector: 'app-payment-share-member-modal-member-table',
  template: `
    <fl-table
      *ngIf="memberSpendingInfo"
      flTrackingSection="PaymentShareMemberTable"
      [dataSource]="memberSpendingInfo"
      [edgeToEdge]="true"
    >
      <fl-table-col
        [textAlign]="TextAlign.LEFT"
        i18n-title="payment sharing member's spend limit column header"
        title="Max spend limit"
      >
        <ng-template #cell let-member>
          <ng-container *ngIf="member.isSpendingLimitActive">
            {{ member.spendingLimitAmount | flCurrency: member.currency?.code }}
          </ng-container>
          <ng-container
            *ngIf="!member.isSpendingLimitActive"
            i18n="No spending limit for the team member"
          >
            No Limit
          </ng-container>
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.LEFT"
        i18n-title="Payment sharing member's time period column header"
        title="Time period"
      >
        <ng-template #cell let-member>
          <ng-container [ngSwitch]="member.spendingLimitDuration">
            <ng-container
              *ngSwitchCase="PaymentShareSpendingLimitDurationApi.NO_TIME_LIMIT"
              i18n="No spending limit for the team member"
            >
              No Limit
            </ng-container>
            <ng-container
              *ngSwitchCase="PaymentShareSpendingLimitDurationApi.PER_MONTH"
              i18n="Payment sharing member's time period is set to per month"
            >
              Monthly
            </ng-container>
            <ng-container
              *ngSwitchDefault
              i18n="The payment sharing member's time period is not available"
            >
              N/A
            </ng-container>
          </ng-container>
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.RIGHT"
        i18n-title="Payment sharing member's spent in this period column header"
        title="Spent this period"
      >
        <ng-template #cell let-member>
          <ng-container *ngIf="member.currentSpentAmount !== undefined">
            {{ member.currentSpentAmount | flCurrency: member.currency?.code }}
          </ng-container>
          <ng-container *ngIf="member.currentSpentAmount === undefined">
            <fl-spinner
              flTrackingLabel="PaymentShareLoadSpending"
              [color]="SpinnerColor.GRAY"
              [size]="SpinnerSize.SMALL"
            ></fl-spinner>
          </ng-container>
        </ng-template>
      </fl-table-col>
      <fl-table-col
        [textAlign]="TextAlign.RIGHT"
        i18n-title="Payment sharing member's balance left column header"
        title="Balance left this period"
      >
        <ng-template #cell let-member>
          <ng-container
            *ngIf="
              member.isSpendingLimitActive &&
              member.currentSpentAmount !== undefined
            "
          >
            {{
              member.spendingLimitAmount - member.currentSpentAmount
                | flCurrency: member.currency?.code
            }}
          </ng-container>
          <ng-container
            *ngIf="
              member.isSpendingLimitActive &&
              member.currentSpentAmount === undefined
            "
          >
            <fl-spinner
              flTrackingLabel="PaymentShareLoadBalanceLeft"
              [color]="SpinnerColor.GRAY"
              [size]="SpinnerSize.SMALL"
            ></fl-spinner>
          </ng-container>
          <ng-container
            *ngIf="!member.isSpendingLimitActive"
            i18n="Spending limit is not activated, the balance left is N/A"
          >
            N/A
          </ng-container>
        </ng-template>
      </fl-table-col>
    </fl-table>
  `,
})
export class PaymentShareMemberModalMemberTableComponent {
  Margin = Margin;
  HeadingType = HeadingType;
  TextSize = TextSize;
  TextAlign = TextAlign;
  PaymentShareSpendingLimitDurationApi = PaymentShareSpendingLimitDurationApi;
  SpinnerColor = SpinnerColor;
  SpinnerSize = SpinnerSize;

  @Input() memberSpendingInfo: readonly PaymentShareMemberSpendingInfo[];
}
